
import universal, { setHasBabelPlugin } from '/opt/build/repo/node_modules/react-universal-component/dist/index.js'


setHasBabelPlugin()

const universalOptions = {
  loading: () => null,
  error: props => {
    console.error(props.error);
    return <div>An error occurred loading this page's template. More information is available in the console.</div>;
  },
}

const t_0 = universal(import('../node_modules/react-static/lib/browser/components/Default404'), universalOptions)
const t_1 = universal(import('../src/containers/homepage'), universalOptions)
const t_2 = universal(import('../src/containers/calendar'), universalOptions)
const t_3 = universal(import('../src/containers/event'), universalOptions)
const t_4 = universal(import('../src/containers/events'), universalOptions)
const t_5 = universal(import('../src/containers/page'), universalOptions)


// Template Map
export default {
  '../node_modules/react-static/lib/browser/components/Default404': t_0,
'../src/containers/homepage': t_1,
'../src/containers/calendar': t_2,
'../src/containers/event': t_3,
'../src/containers/events': t_4,
'../src/containers/page': t_5
}

export const notFoundTemplate = "../node_modules/react-static/lib/browser/components/Default404"
